import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CgvService {
  private cgvAccepted = new BehaviorSubject<boolean>(false); // Valeur initiale : false
  cgvAccepted$ = this.cgvAccepted.asObservable(); // Observable pour écouter l'état de l'acceptation des CGV

  // Fonction pour marquer les CGV comme acceptées
  acceptCGV(): void {
    this.cgvAccepted.next(true);  // Change l'état à true lorsque l'utilisateur accepte
  }

  // Fonction pour réinitialiser l'acceptation des CGV
  resetCGV(): void {
    this.cgvAccepted.next(false);  // Réinitialise l'état à false
  }

}
